import React from 'react';
import '../css/comman.css';
import { Redirect,NavLink} from 'react-router-dom';
import {Form, FormGroup, Label, Input, FormText,Badge } from 'reactstrap';

const required = (val) => val && val.length;
const validEmail = (val) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i.test(val);

class Login extends React.Component{
    constructor(props){
        // console.log("page loaded");
        super(props);
        this.state = {
            email:"",
            password:"",
            checkBox:false,

            // error messages
            errorEmail:"",
            errorPassword:"",
            errorLogin:this.props.user.errMess,

            // button handling
            buttonText:"Submit",
            buttonDisable:false,

            isDisabled:true,
        }
    }


    mySubmitHandler = (event) => {
        event.preventDefault();
        // this.setState({password:""});
        if(validEmail(this.state.email)){
            if(required(this.state.password)){
                console.log("username: ", this.state.email);
                console.log("password ", this.state.password);
                this.setState({
                    buttonDisable:true,
                    buttonText:"Sending..."
                });
                this.props.loginUser({
                    "username":this.state.email.toLowerCase(),
                    "password":this.state.password
                })
                .then(()=>{
                    // console.log("Trying to get some stats\n\n");
                    this.setState({
                        buttonDisable:true,
                        buttonText:"Logging..."
                    });
                    this.props.getStats();
                },(err)=>{
                    throw err;
                })
                .catch((err)=>{
                    this.setState({
                        buttonDisable:false,
                        buttonText:"Submit"
                    });
                    console.log("inside login err: ",err)
                });
            }
            else{
                this.setState({errorPassword: "Password cannot be empty"});
            }
        }
        else{
            this.setState({errorEmail: "Invalid Email"});
        }
    }

    myChangeHandler = (event) => {
        let nam = event.target.name;
        let val = event.target.value;
        this.setState({[nam]: val});
    }

    validate = (event)=>{
        let nam = event.target.name;
        let val = event.target.value;
        if(nam==="email" && !validEmail(val)){
            this.setState({errorEmail: "Invalid Email"});
        }
        else if(nam==="email" && validEmail(val)){
            this.setState({errorEmail:""});
        }
    }
    handleCheckBox = (event) =>{
        this.setState({
            checkBox:!this.state.checkBox
        })
    }

    render(){
        if(this.props.user.isAuthenticated){
            return(
                <Redirect to="/dashboard"/>
            )
        }
        return(
            <div className="container">
                <div className="row justify-content-center login">
                    <Form  onSubmit={this.mySubmitHandler}>
                        <FormGroup className="mt-100">
                            <Label for="email">Email</Label>
                            <Input
                                className="col"
                                id="email"
                                type='text'
                                name='email'
                                onChange={this.myChangeHandler}
                                value={this.state.email}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errorEmail}</FormText>
                        </FormGroup>
                        <FormGroup>
                            <Label for="password">Password</Label>
                            <Input
                                className="col"
                                id="password"
                                type={this.state.checkBox?"text":"password"}
                                name='password'
                                onChange={this.myChangeHandler}
                                value={this.state.password}
                                onBlur={this.validate}
                            />
                            <FormText color="danger">{this.state.errorPassword}</FormText>
                        </FormGroup>
                        <div>
                            <input 
                                type="checkbox" 
                                checked={this.state.checkBox} 
                                onChange={this.handleCheckBox}
                                />
                            <label>Show Password</label>
                        </div>
                        <input 
                            type='submit' 
                            value={this.state.buttonText}
                            disabled={this.state.buttonDisable}
                            />
                        <FormGroup className="mt-2">
                            <div className="m-auto">
                                <div>
                                    <h5>
                                        <Badge color="primary">
                                            <NavLink to="/emailforgotpassword" style={{color:"#EFEFEF"}}>Forgot Password</NavLink>
                                        </Badge>
                                    </h5>
                                </div>
                                <div>
                                    <h5>
                                        <Badge color="primary">
                                            <NavLink to="/signup" style={{color:"#EFEFEF"}}>SignUp</NavLink>
                                        </Badge>
                                    </h5>
                                </div>
                            </div>
                        </FormGroup>
                        <FormText color="danger">{this.state.errorLogin==="Failed to fetch"?"Server is down. Please try again":this.props.user.errMess}</FormText>
                    </Form>
                    <div >
                        {/* <h4><Badge color="danger">{this.state.errorLogin}</Badge></h4> */}
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;